export default __webpack_public_path__ + "static/media/create-audio-for-lecture-feature.78bde846.webp";